import api, { ResponseCallback } from '../services/api.service'
import { InventoryData } from './inventory.api'

export interface StandaloneCasesCreateRequest {
  workOrder?: number
  quantity?: number
  reference?: string
}

const routes = {
  create: '/standaloneCases'
}

export default {
  create (
    payload: StandaloneCasesCreateRequest,
    callback: ResponseCallback<InventoryData>
  ) {
    api.post(routes.create, payload, callback)
  }
}
